import React, { useEffect, useState } from 'react'
import getDataFromCube from '../../utils/getCubeData';
import { makeStyles } from "@mui/styles";
import { Select, MenuItem, ListItemText, Checkbox, LinearProgress, Button, Paper, IconButton, InputAdornment, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { ReactComponent as InputSearchIcon } from "../../assets/icons/icon-feather-search.svg"
import _ from 'lodash';



const useStyles = makeStyles({
    header: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        marginTop: '-8px',
    },
    search: {
        marginBottom: "1px",
    },
    card: {
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        display: 'flex',
        backgroundColor: "#fff4f0",
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
});

export default function ReportFilterFormValuesDb({ filterCondtion, i, filterFormStateChange }) {
    const [fechData, setFechData] = useState([]);
    const [fetchingLoader, setFetchingLoader] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchData, setSearchData] = useState([])
    const [searchLoader,setSearchLoader] = useState(false)

    const classes = useStyles();

    const fetchedDataFromCube = async () => {
        setFetchingLoader(true)
        let fetchedData;
        if (filterCondtion?.dynamicLabel) {
            fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType, undefined, "filterDynamicLabel", filterCondtion?.dynamicLabel);
        } else {
            fetchedData = await getDataFromCube(filterCondtion?.member, filterCondtion?.dataSetType);
        }
        setFechData([...fetchedData]);
        setFetchingLoader(false)
    }
    // add useRef
    useEffect(() => fetchedDataFromCube(), [filterCondtion]);

    const handleChange = (e) => {
        let val;
        const { value } = e.target;
        if(value === 'all') {
            val = [...fechData]
        }
        else if(value === null) {
            val = []
        }
        else {
            val = value
        }

        filterFormStateChange("operatorvalues", i, val)
    }

    const handleUnSelectAll = () => {
        let e = {target:{value: null}}
        handleChange(e)
    }

    const handleSelectAll = () => {
        let e = {target:{value: 'all'}}
        handleChange(e)
    }

    const handleMenuOpen = () => {
        setSearchData([])
        setSearchLoader(false)
        setMenuOpen(!menuOpen)
    }
    const handleMultiSelect = (e) => {
        if (filterCondtion?.values.length) {
            !filterCondtion?.values?.some(ele => ele === e?.target?.value[0]) ? e.target.value = [...e.target.value, ...filterCondtion?.values] : e.target.value = filterCondtion?.values.filter(ele => ele !== e.target.value[0])
        }
        handleChange(e)
    }


    const MultiSelectRow = ({ index, style, data }) => {
        let label = data[index];
        let value = data[index];

        if (filterCondtion?.dynamicLabel) {
            const item = data[index];
            label = item[filterCondtion?.dynamicLabel?.label]
            value = item[filterCondtion?.member]
        }
        return <div style={style} key={value}>
            <MenuItem title={label} onClick={(e) => handleMultiSelect({ target: { value: [value] } })} className={classes.menuDropdownItem + " menu-item flex"} value={value}>
                <Checkbox className="form_checkbox" checked={filterCondtion?.values?.indexOf(value) > -1} />
                <ListItemText primary={label} />
            </MenuItem>
        </div>
    }

       const handleFilterSearchInput = async (e, cb) => {
         e.stopPropagation();
            const value = e?.target?.value
            if(value === "") {
                setSearchData([])
                setSearchLoader(false)
            } 
            else {
                let filterQuery = [{
                    member: filterCondtion?.member,
                    operator: 'contains',
                    values: [value]
                }]
                let query = {}
                if(filterCondtion?.dataSetType=== 'MEASURE') {
                    query['measures'] = [filterCondtion?.member]
                }
                else if(filterCondtion?.dataSetType === "DIMENSION") {
                query['dimensions'] = [filterCondtion?.member]
                }
                query.filters = filterQuery

                const searchValues = await getDataFromCube(null,null,null,"custom_query_data",query)
                const fData = searchValues?.map(f => f[filterCondtion?.member])
                cb(fData)
                setSearchLoader(false)
            }
    };
    const debouncedFetchData = _.debounce((e, cb) => {
        setSearchLoader(true)
        handleFilterSearchInput(e, cb);
    }, 500);



    return (
        <>
            {searchLoader && <LinearProgress />}
            {(fetchingLoader) ? <LinearProgress /> :

                <Select
                    multiple
                    value={filterCondtion?.values && filterCondtion?.values?.length ? [...new Set(filterCondtion?.values)] : [`Select ${filterCondtion?.displayName || filterCondtion?.member?.split('.')[1]}`]}
                    renderValue={(selected) => selected.join(", ")}
                    onChange={(e) => handleChange(e)} size='small'
                    open={menuOpen}
                    onClose={handleMenuOpen}
                    onOpen={handleMenuOpen}
                    className="report_form_ui_input_select"
                    MenuProps={{
                        classes: {
                            root: `form-select-menu`
                        }
                    }}
                >
                    <div className={classes.header}>
                        <Paper className={classes.card} elevation={3}>
                            <IconButton className="form-icon-btn" onClick={handleMenuOpen} color="primary"> <CancelIcon /></IconButton>
                        </Paper>
                    </div>
                    <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search..."
                        onChange={e => debouncedFetchData(e,res => {
                            setSearchData(res)
                        })}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start">
                                    <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                                </InputAdornment>
                            ),
                        }} />

                    {    
                    filterCondtion?.values?.length !== fechData?.length ?
                      <Paper className={classes.card} elevation={3}>
                            <Button className="form_btn_outline" size='small' variant="outlined" onClick={handleSelectAll} >Select All</Button>
                      </Paper>   
                        :
                        <Paper className={classes.card} elevation={3}>
                            <Button className="form_btn_outline" size='small' variant="outlined" onClick={handleUnSelectAll} >UnSelect All</Button>
                       </Paper>

                  }   

                    <div className={`virtual-filter-div ` + ((searchData.length || fechData.length) ? 'filter-data-exists' : ``)}>
                        <AutoSizer>
                            {({ height, width }) => (
                                <FixedSizeList
                                    className="List"
                                    height={(searchData.length ? searchData : fechData).length ? height : 20}
                                    itemCount={(searchData.length ? searchData : fechData).length}
                                    width={width - 6}
                                    itemData={(searchData.length ? searchData : fechData)}
                                    itemSize={35}
                                >
                                    {MultiSelectRow}
                                </FixedSizeList>
                            )}
                        </AutoSizer>
                    </div>

                </Select>
            }
        </>
    )
}